import axios from 'axios';
import { verifyEnvUrl } from 'util/verifyEnvUrl';

const PROD_URL = 'https://api.acordofechado.com.br/authentication';
const DEV_URL = 'https://us-central1-acordo-fechado-dev.cloudfunctions.net/authenticationApiDev';

const authenticationApi = axios.create( {
	// baseURL: 'http://localhost:8080'
	baseURL: verifyEnvUrl( PROD_URL, DEV_URL ),
} );

authenticationApi.interceptors.request.use( async config => {
	const token = localStorage.getItem( 'af-token' );
	if ( token ) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
} );

export default authenticationApi;
